import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EnvConfigService } from '../utils/env-config.service';
import { isLoginSuccess } from './login-response';
// import Swal from 'sweetalert2'

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {
  private API_URL = environment.API_URL?.split('/rrhh')[0];
  usuario?: any;
  ejecutarRefresh: boolean = true;

  intervalID: any = null;

  enHome = signal<boolean>(false);

  constructor(
    private http: HttpClient,
    private router: Router,
    private envConfigService: EnvConfigService
  ) {

    console.log('constructor', this.router.url);

    this.enHome.set(this.router.url === '/' || this.router.url.includes('home'));

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.enHome.set(event.url === '/' || event.url.includes('home'));
      }
    });
  }

  async canDoSomething() {
    return new Promise((resolve) => {
      let interval = setInterval(() => {
        this.API_URL = environment.API_URL?.split('/rrhh')[0];
        if (!!this.API_URL) {
          clearInterval(interval);
          resolve(true);
        }
      }, 100);
    });
  }

  async refreshToken(): Promise<Observable<boolean> | null> {
    // Esperar a que canDoSomething responda
    await this.canDoSomething();
    
    if (!this.API_URL) return null;
    
    const token = localStorage.getItem('token') || '';
    const url = this.API_URL + `/token/refresh`;

    

    // private readonly user$ = new BehaviorSubject<any>({});
    // selectedUser$ = this.user$.asObservable();

    const refresh = {
      data: {
        token,
        // aplicacion: 'personal'
      }
    };
    return this.http.post(url, refresh).pipe(
      tap((resp: any) => {
        this.guardarStorage(resp.data.token, resp.data.user);
      }),
      map((resp) => true)
      // catchError(err => of(false))
    );
  }

  SaveStorage(json: any) {
    
    
    

    localStorage.setItem('token', json.token);

    localStorage.setItem('usuario', JSON.stringify(json.data));
  }

  guardarStorage(token: string, usuario: any) {
    localStorage.setItem('token', token);
    localStorage.setItem('usuario', JSON.stringify(usuario));
  }

  // setUserData() {
  //   this.product$.next(product);
  // }

  removeStorage() {
    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
    localStorage.removeItem('urldebusqueda');
  }

  async login(formdata: any): Promise<Observable<any> | null> {
    await this.canDoSomething();
    if (!this.API_URL) return null;
    
    
    // localStorage.setItem('username', formdata)
    const url = this.API_URL + `/token/login`;
    return this.http.post(url, formdata).pipe(
      tap((resp: any) => {
        // La API rechaza credenciales con HTTP 200 y code 401 sin token:
        // solo se guarda sesión si la respuesta es un éxito completo.
        if (isLoginSuccess(resp)) {
          this.guardarStorage(resp.data.token, resp.data.user);
        }
      })
    );
  }

  logout(): void {    
    this.removeStorage();
  }

  verificarCaducudadToken(): boolean {
    const token = localStorage.getItem('token');
    if (!token || token === 'undefined' || token === 'null') {
      this.removeStorage();
      return false;
    }

    try {
      const tokenPart = token.split('.')[1];
      if (!tokenPart) throw new Error('Token sin payload');
      const payload = JSON.parse(atob(tokenPart));
      if (!Number.isFinite(Number(payload?.exp)) || this.expirado(Number(payload.exp))) {
        this.removeStorage();
        return false;
      }

      void this.verificaRenueva(Number(payload.exp));
      return true;
    } catch {
      this.removeStorage();
      return false;
    }
  }

  async verificaRenueva(fechaExp: number) {
    let tokenExp = new Date(fechaExp * 1000);
    let ahora = new Date();

    // ahora en 30 minutos en el futuro
    ahora.setTime(ahora.getTime() + 30 * 60 * 1000);

    
    

    if (this.ejecutarRefresh) {
      // esto verifica si el token expirara en menos de 30 minutos
      if (tokenExp.getTime() < ahora.getTime()) {
        this.ejecutarRefresh = false;

        const refreshObservable = await this.refreshToken();
        if (refreshObservable) {
          refreshObservable.subscribe(
            (respuesta) => {
              this.ejecutarRefresh = true;
            },
            (err) => {
              this.ejecutarRefresh = true;
              
              // Swal.fire({
              //   position: 'top-end',
              //   icon: 'error',
              //   title: 'Refresh Token',
              //   html: 'Tenemos problemas al refrescar el token.',
              //   showConfirmButton: false,
              //   timer: 4000
              // })
            }
          );
        }
      }
    }
  }

  expirado(fechaExp: number) {
    // getTime nos llega en milisegundos por eso lo dividimos entre 1000
    let ahora = new Date().getTime() / 1000;
    
    // ahora = ahora + 3730;
    
    
    
    
    if (fechaExp < ahora) {
      
      return true;
    } else {
      
      return false;
    }
  }
}
